export default __webpack_public_path__ + "static/media/Formato-Propuesta-Invitacion-Museos-2025.7fef87ac.docx";